import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CertificateContainer = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 48px auto;
  padding: 0px 24px;
  max-width: 1136px;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    gap: 40px;
    flex-direction: row;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 64px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 0px;
    margin: 100px auto;
    gap: 94px;
  }
`;

export const ImageWrapperCertificate = styled(Box)`
  max-width: 250px;
  max-height: 180px;
  margin: 0 auto;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: 344px;
    max-height: 247px;
    margin: 0;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 460px;
    max-height: 330px;
  }
`;
